import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

/** Two-level app breadcrumb: `rootLabel › sectionLabel`. Shared by the provider,
 *  client-portal, and platform/marketplace headers so every screen shows a path. */
export function PathBreadcrumb({
  rootLabel,
  sectionLabel,
}: {
  rootLabel: string;
  sectionLabel: string;
}): JSX.Element {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem className="hidden text-muted-foreground md:block">
          {rootLabel}
        </BreadcrumbItem>
        <BreadcrumbSeparator className="hidden md:block" />
        <BreadcrumbItem>
          <BreadcrumbPage>{sectionLabel}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}

/** Resolve a URL segment to a section label, falling back to a title-cased
 *  version of the segment so an unmapped route still reads sensibly. */
export function labelFor(labels: Record<string, string>, key: string): string {
  if (labels[key]) return labels[key];
  if (!key) return "Home";
  return key.charAt(0).toUpperCase() + key.slice(1).replace(/-/g, " ");
}
